import { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined} from '@ant-design/icons';
import SweetAlert from "sweetalert2";

import Tab1 from "./Tab1";
import { Typography } from '@mui/material';

import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import Tab2 from "./Tab2";
import { TypeGarantieCompteGLDto, TypeGarantieDto } from "../../../Models/TypeGarantieDto";


// ─── Types exportés pour Typegarantie ────────────────────────────────────────
// export interface BranchGlRow {
//     Id: string | number;
//     CodeAgence: string;
//     LibelleAgence?: string;
//     GlCompteTransit: string;
//     GlCompteGarantie: string;
//     GlCompteContrepartie: string;
//     GlCompteHorsBilan: string;
//     GlCompteDeblocage: string;
//     status?: 'new' | 'modified' | 'existing';
// }

const Typegarantie = () => {

    const auth = useAuthUser();
    const authHeader = useAuthHeader();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
    const [glTypeGarantie,setglTypeGarantie]=useState<TypeGarantieCompteGLDto[]>([]);

    const [Activetabs, SetActivetabs] = useState(false);

    // Handle function
    function HandleConsult() {
        // setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false);
        SetActivetabs(true)
  
    }
    

    function HandleAjout() {
        form.resetFields();
        setglTypeGarantie([]);
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSearchGlobal(true);
        setSbmit('add');

    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
        SetActivetabs(false)
        setSearchGlobal(true);
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {

        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
        setglTypeGarantie([]);
        SetActivetabs(false);
       setSearchGlobal(false);
    }


    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='1'>
                    <UserOutlined />
                   Paramétrage général du type de financement
                </span>
            ),
            children: <Tab1  setGlRows={setglTypeGarantie} glRows={glTypeGarantie}   etatG={SearchGlobal} form={form}/>
        },
        {
            key: '2',
            label: (
                <span id='2'>
                    <UserOutlined />
                     Financement corespondant
                </span>
            ),
            children: <Tab2  form={form}/>
        }
        
    ];

    // function consult 
    function consult()
     {
        if (form.getFieldValue("CodeTypeGarantie") == null) 
        {
            SweetAlert.fire({ title: "Svp renseigner le Code du type de garantie", icon: "warning" });
        } else 
        {
            let data = (form.getFieldValue("CodeTypeGarantie"));
           
            if (data.length != 0) 
            {
                setLoading(true)

                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadTypeGarantie,
                    headers: {
                        'CypherCodeTypegarantie': Crypter.encrypt(data),
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => 
                     {
                        setLoading(false);
                        if (response.data) 
                        {
                            //const res = JSON.parse(Crypter.decrypt(response.data));
                            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                            console.log(res);
                        //  alert(JSON.stringify(res));

                            if (res.StatutCode == 200) 
                            {
                                 let  TypeGarantie: TypeGarantieDto = res.Result.Table1[0];
                                 TypeGarantie.CodeFinancement=res.Result.Table2.map((x: any) => x.CodeFinancement);
                                  const configGL: TypeGarantieCompteGLDto[] =
                                    res.Result.Table3.map((x: any) => ({
                                        Id: x.Id ?? x.CodeAgence,
                                        CodeAgence: x.CodeAgence,
                                        LibelleAgence: x.LibelleAgence,
                                        GLCompteTransit: x.GLCompteTransit,
                                        GLCompteGarantie: x.GLCompteGarantie,
                                        GLCompteContrepartie: x.GLCompteContrepartie,
                                        GLCompteHorsBilan: x.GLCompteHorsBilan,
                                        GLCompteDeblocage: x.GLCompteDeblocage,
                                        IsActif: x.IsActif
                                    }));

                                       setglTypeGarantie(configGL);
                                       TypeGarantie.ConfigurationGL = configGL;
                               
                                 form.setFieldsValue(TypeGarantie);
                                  HandleConsult();
                                

                            }
                            else
                           {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => 
                    {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }

    // function Onfinish
    const onFinish = () => 
     {
        //console.log(values)
         const values = form.getFieldsValue(true);
        
         var Typegaratie: TypeGarantieDto = values;
             Typegaratie.Createdby =user.coduti;
             Typegaratie.ConfigurationGL=glTypeGarantie;
         
              let data = Crypter.encrypt(JSON.stringify(Typegaratie));

            if (sbmit == "add" ) 
            {
                SweetAlert.fire({
                    title: "Création du Paramètre du type de garantie",
                    text: "Voulez-vous Créer le type de garantie " ,
                    showCancelButton: true,
                    color: "#116599",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#116599",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: "question"
                }).then((res) => 
                {
                    if (res.isConfirmed) 
                    {
                        setLoading(true);
                        setIsSubmit(true);
                        //console.log(JSON.stringify(DemandVP));
                       

                      
                        let config = 
                        {
                            method: 'post',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.CreateTypeGarantie,
                            headers: 
                            {
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                            data: data
                        };
                        axios.request(config)
                            .then((response) => 
                              {
                                setLoading(false);
                                if (response.data) 
                                 {
                                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                   
                                    if (res.StatutCode == 200) 
                                    { 
                                       SweetAlert.fire({ title: res.Message, text: res.Result , icon: "success" });
                                        HandleAnnul();
                                    }
                                    else 
                                    {
                                        SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                                    }
                                }
                            })
                            .catch((error) => 
                            {
                                setLoading(false);
                                console.log(error)
                                SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                            });
                    }
                })
            }
            // ********************************************************************************************************************************
            if (sbmit == "modif") 
            {
                SweetAlert.fire({
                    title: "Mise à jour du Type de garantie",
                    text: "Voulez-vous mettre à jour le type de garantie " + Typegaratie.CodeFinancement ,
                    showCancelButton: true,
                    color: "#116599",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#116599",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: "question"
                }).then((res) => 
                {
                    if (res.isConfirmed) 
                    {
                        setLoading(true);
                        setIsSubmit(true)
                        //console.log(JSON.stringify(DemandVP));
                        
                        let config = 
                        {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.UpdateTypeGarantie,
                            headers: {
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                            data: data
                        };
                        axios.request(config)
                         .then((response) => 
                            {
                                setLoading(false);
                                if (response.data) 
                                {
                                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                    // alert(JSON.stringify(res))
                                    console.log(res)
                                    if (res.StatutCode == 200) 
                                    { 
                                            SweetAlert.fire({ title: res.Message, text: res.Result , icon: "success" });
                                            HandleAnnul();
                                    }
                                    else 
                                    {
                                        SweetAlert.fire({ title:res.Message, text: res.Result, icon: "warning" })
                                    }
                                }
                            })
                            .catch((error) => 
                            {
                                setLoading(false);
                                console.log(error);
                                SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                            });
                    }
                })
        } 
    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => 
    {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => 
        {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };


    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form disabled={FormAct}  preserve scrollToFirstError autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Désactiver 
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button> */}
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default Typegarantie;